module.exports = __webpack_public_path__ + "static/media/Neoptolemus.2afb12e0.jpg";